
import React from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Import } from "lucide-react";
import ImportForm from "./ImportForm";
import ImportResults from "./ImportResults";
import { useImporter } from "./useImporter";

interface SceneIdeasImporterProps {
  onImportComplete: () => void;
}

const SceneIdeasImporter: React.FC<SceneIdeasImporterProps> = ({ onImportComplete }) => {
  const {
    importFormat,
    importText,
    isImporting,
    importStats,
    handleFormatChange,
    setImportText,
    loadExample,
    handleImport,
    getPlaceholderText
  } = useImporter(onImportComplete);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Import className="h-5 w-5 text-elfGreen" />
          Bulk Import Elf Scenes
        </CardTitle>
        <CardDescription>
          Import multiple elf scene ideas at once using JSON or CSV format
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <ImportForm 
          importFormat={importFormat}
          importText={importText}
          onFormatChange={handleFormatChange}
          onTextChange={(value) => setImportText(value)}
          loadExample={loadExample}
        />
        
        <ImportResults stats={importStats} />
      </CardContent>
      <CardFooter className="flex justify-end">
        <Button
          onClick={handleImport}
          disabled={isImporting || !importText.trim()}
          className="bg-elfGreen hover:bg-elfGreen-dark gap-2"
        >
          <Import className="h-4 w-4" />
          {isImporting ? "Importing..." : "Import Elf Scenes"}
        </Button>
      </CardFooter>
    </Card>
  );
};

export default SceneIdeasImporter;
